import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Modal from 'components/ui/modal';
import Input from 'components/form/Input';
import Button from 'components/common/Button';

const styles = (theme) => ({
  root: {
    minWidth: 360,
    [theme.breakpoints.down('sm')]: {
      minWidth: 30,
    },
  },
  input: {
    marginBottom: theme.spacing(3),
  },
});

const getDescription = (emails, contact) => {
  if (contact === 'ALL') return 'Sending invite to all your contacts.';
  if (contact) {
    if (!contact.first_name && !contact.last_name) {
      return contact.email || contact.phone;
    }
    return `Sending invite to ${contact.first_name} ${contact.last_name || ''}`;
  }
  return `Sending invitation to ${emails.length} contacts`;
};

const InviteModal = ({ onClose, onSubmit, classes, emails, contact }) => {
  const [message, setMessage] = useState('');
  const handleSubmit = () => {
    return onSubmit(message);
  };

  return (
    <Modal
      fullWidth
      open
      maxWidth="sm"
      title="Send Invite"
      onClose={onClose}
      actions={[
        <Box padding={1} margin="auto">
          <Button variant="contained" color="primary" onClick={handleSubmit}>
            Send Invite
          </Button>
        </Box>,
      ]}
    >
      <Box className={classes.root}>
        <Typography variant="small" color="textSecondary">
          {getDescription(emails, contact)}
        </Typography>
        <Box marginTop={3}>
          <Input
            fullWidth
            multiline
            rows={5}
            classes={{ root: classes.input }}
            margin="normal"
            variant="outlined"
            label="Feel free to add message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
        </Box>
      </Box>
    </Modal>
  );
};

export default withStyles(styles)(InviteModal);
